/* eslint-disable no-return-assign */
/* eslint-disable no-alert */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { Acl } from 'modules/common/components/Acl';
import { ModalContext } from 'App';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { get, getJson } from 'session';
import Alert from 'react-s-alert';
import PropTypes from 'prop-types';
import ViewSOA from './ViewSOA';
import * as actions from '../actions';
import * as c from '../constant';
import ActivityComponent from './ActivityComponent';

const formatPeriod = (data) => {
  let val = '';
  switch (data) {
    case 0:
      val = '1st Quarter';
      break;
    case 1:
      val = '1st Quarter';
      break;
    case 2:
      val = '2nd Quarter';
      break;
    case 3:
      val = '3rd Quarter';
      break;
    case 4:
      val = '4th Quarter';
      break;
    default:
      val = '';
      break;
  }
  return val;
};
function UpdateCalculationsRetirementMultiple({
  data,
  getItem,
  formData,
  setFormData,
  assessRetirementRequest,
  generateSOARetirement,
  getLatestPaid,
  updating,
}) {
  const setModal = useContext(ModalContext);
  const businessActivityList = _.get(data, 'included.bplsBusinessActivities');
  const isFullRetirement = _.get(
    data,
    'included.bplsRetirements.attributes.is_full_retirement'
  );
  const retiredActivitiesList = _.get(
    data,
    'included.bplsRetirements.attributes.activities'
  );
  const permissions = getJson('permissions');
  const [latestPaidData, setLatestPaidData] = useState(null);
  const [years, setYears] = useState([]);
  const [collapsed, setCollapsed] = useState({});
  const currentYear = new Date().getFullYear();

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const buildActivitiesForYear = (year) => {
    if (isFullRetirement) {
      return Object.keys(businessActivityList).map((activity) => ({
        year,
        activity_id: _.get(businessActivityList, `${activity}.id`) || '',
        gross_amount:
          _.get(businessActivityList, `${activity}.attributes.gross_amount`) ||
          '',
        name: _.get(businessActivityList, `${activity}.attributes.name`) || '',
      }));
    }
    return Object.keys(businessActivityList)
      .map(
        (activity) =>
          retiredActivitiesList.indexOf(
            _.get(businessActivityList, `${activity}.id`)
          ) > -1 && {
            year,
            activity_id: _.get(businessActivityList, `${activity}.id`) || '',
            gross_amount:
              _.get(
                businessActivityList,
                `${activity}.attributes.gross_amount`
              ) || '',
            name:
              _.get(businessActivityList, `${activity}.attributes.name`) || '',
          }
      )
      .filter((activity) => activity !== false);
  };
  useEffect(() => {
    getLatestPaid(_.get(data, 'included.bplsBusiness.id'), (response) => {
      const year = _.get(response, 'data.attributes.year') || '';
      const parsedYear = parseInt(year, 10);
      setLatestPaidData({
        ..._.get(response, 'data.attributes'),
        year: parsedYear,
      });
      const startYear = parsedYear;
      setYears([startYear]);
      setFormData({
        ...formData,
        activities: buildActivitiesForYear(startYear),
        override_amount: 0,
      });
    });
  }, []);

  const onCheck = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked === true ? 1 : 0,
    });
  };

  const handleAddYear = () => {
    const maxYear = Math.max(...years);
    const newYear = maxYear + 1;
    if (newYear > currentYear) return;
    const newActivities = buildActivitiesForYear(newYear);
    setYears([...years, newYear]);
    setFormData({
      ...formData,
      activities: [..._.get(formData, 'activities', []), ...newActivities],
    });
  };

  const handleDeleteYear = (yearToDelete) => {
    if (yearToDelete <= _.get(latestPaidData, 'year')) return;
    const updatedYears = years.filter((y) => y !== yearToDelete);
    const updatedActivities = _.get(formData, 'activities', []).filter(
      (a) => a.year !== yearToDelete
    );
    setYears(updatedYears);
    setFormData({
      ...formData,
      activities: updatedActivities,
    });
  };

  const toggleCollapse = (year) => {
    setCollapsed((prev) => ({ ...prev, [year]: !prev[year] }));
  };

  const validateConsecutiveYears = () => {
    if (years.length <= 1) return true;
    const sorted = [...years].sort((a, b) => a - b);
    for (let i = 1; i < sorted.length; i += 1) {
      if (sorted[i] !== sorted[i - 1] + 1) return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (years.length === 0) {
      Alert.error('Please add at least one year before submitting.');
      return;
    }

    if (!validateConsecutiveYears()) {
      Alert.error(
        'Years must be consecutive. Please add the missing years or remove gaps before submitting.'
      );
      return;
    }

    const allActivities = _.get(formData, 'activities', []);
    const args = {
      activities: allActivities.map((item) => ({
        activity_id: item.activity_id,
        gross_amount: item.gross_amount,
        year: item.year,
      })),
      override_amount: _.get(formData, 'override_amount'),
    };
    const soa_args = allActivities.map((item) => ({
      activity_id: item.activity_id,
      amount: item.amount,
      discount: item.discount,
      penalty: item.penalty,
      year: item.year,
    }));
    assessRetirementRequest(_.get(data, 'id'), args, () => {
      generateSOARetirement(
        _.get(data, 'id'),
        { business_activities: soa_args },
        (response) => {
          getItem(_.get(data, 'id'));
          setModal({
            isOpen: true,
            content: <ViewSOA data={data} generateAmount={response} />,
            title: 'View e-SOA',
            modalSize: 'modal-xl',
          });
        }
      );
    });
  };

  const getGlobalIndex = (year, localIndex) => {
    const allActivities = _.get(formData, 'activities', []);
    let count = 0;
    for (let i = 0; i < allActivities.length; i += 1) {
      if (allActivities[i].year === year) {
        if (count === localIndex) return i;
        count += 1;
      }
    }
    return -1;
  };

  const maxYear = years.length > 0 ? Math.max(...years) : 0;
  const canAddYear = maxYear < currentYear;
  console.log(_.get(latestPaidData, 'qtr_to'));
  return (
    <Modal.Body>
      <form>
        <div>
          <Tabs>
            <TabList>
              <Tab>Activities for Retirement</Tab>
            </TabList>
            <TabPanel>
              <div className="p-3">
                {_.get(latestPaidData, 'year') === null ? (
                  <div className="text-center p-3">Loading...</div>
                ) : (
                  [...years]
                    .sort((a, b) => a - b)
                    .map((year) => {
                      const yearActivities = _.get(
                        formData,
                        'activities',
                        []
                      ).filter((a) => a.year === year);
                      const isCollapsed = collapsed[year];
                      const canDelete = year > _.get(latestPaidData, 'year');

                      return (
                        <div key={year} className="mb-3 border rounded">
                          <div
                            className="d-flex justify-content-between align-items-center p-3"
                            style={{ cursor: 'pointer' }}
                          >
                            <div
                              className="d-flex align-items-center flex-grow-1"
                              onClick={() => toggleCollapse(year)}
                              role="button"
                              tabIndex={0}
                              onKeyPress={() => toggleCollapse(year)}
                            >
                              <span className="mr-2">
                                {isCollapsed ? '▶' : '▼'}
                              </span>
                              <strong>
                                {year === _.get(latestPaidData, 'year')
                                  ? `Year of Last Payment: ${_.get(latestPaidData, 'year')}`
                                  : year}
                              </strong>
                              <strong className="pl-3 text-danger">
                                {_.get(latestPaidData, 'qtr_to') !== 4
                                  ? `${formatPeriod(_.get(latestPaidData, 'qtr_to'))}`
                                  : ''}
                              </strong>
                            </div>
                            <button
                              type="button"
                              className="btn-blank"
                              onClick={() => handleDeleteYear(year)}
                              disabled={!canDelete}
                              style={!canDelete ? { opacity: 0.35 } : {}}
                            >
                              <i className="far fa-trash-alt icon-delete" />
                            </button>
                            {/* <button
                              type="button"
                              className={`btn btn-sm ${
                                canDelete
                                  ? 'btn-outline-danger'
                                  : 'btn-outline-secondary'
                              }`}
                              disabled={!canDelete}
                              onClick={() => handleDeleteYear(year)}
                              title={
                                canDelete
                                  ? `Remove year ${year}`
                                  : 'Cannot remove this year'
                              }
                            >
                              <span role="img" aria-label="delete">
                                🗑
                              </span>
                            </button> */}
                          </div>
                          {!isCollapsed && (
                            <>
                              <strong className="p-3 pt-0 text-danger">
                                {_.get(latestPaidData, 'qtr_to') !== 4
                                  ? `Remarks: Remaining Quarterly Arrears (${_.get(latestPaidData, 'qtr_to') !== 3 ? `Q${_.get(latestPaidData, 'qtr_to') + 1} to Q4` : 'Q4'}))`
                                  : ''}
                              </strong>
                              <div className="p-3 pt-0">
                                <div className="row">
                                  {yearActivities.map((item, localIdx) => {
                                    const globalIdx = getGlobalIndex(
                                      year,
                                      localIdx
                                    );
                                    return (
                                      <div
                                        className="col-sm-12 col-md-6 form-group"
                                        key={`${year}-${item.activity_id}`}
                                      >
                                        <div className="border border-1 rounded p-3 m-2">
                                          <div>Line of Business:</div>
                                          <div>
                                            <strong>
                                              {_.get(item, 'name') || ''}
                                            </strong>
                                          </div>
                                          <ActivityComponent
                                            itemId={globalIdx}
                                            data={item}
                                            formData={formData}
                                            setFormData={setFormData}
                                          />
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      );
                    })
                )}
                {Acl(permissions, ['OVERRIDE BPLS AMOUNT RETIREMENT']) && (
                  <div className="col-12 form-group">
                    <label htmlFor="last_name" className="form-label">
                      Override Minimum Amount &nbsp;
                    </label>
                    <input
                      name="override_amount"
                      type="checkbox"
                      checked={_.get(formData, 'override_amount')}
                      onChange={onCheck}
                    />
                  </div>
                )}
                <hr />
              </div>
            </TabPanel>
          </Tabs>
        </div>
        <div className="d-flex justify-content-center align-items-center mt-2">
          <button
            type="button"
            onClick={closeModal}
            className="btn btn-dark mr-2"
          >
            <span className="font-weight-bold">Close</span>
          </button>

          <button
            type="button"
            onClick={handleAddYear}
            disabled={!canAddYear || _.get(latestPaidData, 'year') === null}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-dark mr-2"
          >
            <span className="font-weight-bold">+ Add Year</span>
          </button>

          <button
            disabled={updating || _.get(latestPaidData, 'year') === null}
            type="button"
            onClick={handleSubmit}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-dark mr-2"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateCalculationsRetirementMultiple.propTypes = {
  getItem: PropTypes.instanceOf(Function).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  assessRetirementRequest: PropTypes.instanceOf(Function).isRequired,
  generateSOARetirement: PropTypes.instanceOf(Function).isRequired,
  getLatestPaid: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => {
  return {
    item: get(api, `${c.ITEM}.item`) || {},
    vetRegistrationList:
      _.get(api, `${c.GET_VET_REGISTRATION_LIST}.list`) || [],
    updating: api.loading.indexOf(c.UPDATE_DELINQUENT_CALCULATION_DETAIL) > -1,
  };
};

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateCalculationsRetirementMultiple);
